var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9478_26596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4104 9.40364L23.0871 11.7269C26.9592 15.599 26.9592 21.9049 23.0871 25.777C19.215 29.6491 12.9091 29.6491 9.03699 25.777C5.1649 21.9049 5.1649 15.599 9.03699 11.7269L15.2323 5.53155L16.0067 4.6465V0L6.60311 9.40364C5.36749 10.6268 4.38662 12.0828 3.71721 13.6873C3.0478 15.2919 2.70312 17.0133 2.70312 18.752C2.70312 20.4906 3.0478 22.212 3.71721 23.8166C4.38662 25.4212 5.36749 26.8771 6.60311 28.1003C7.82626 29.3359 9.28223 30.3168 10.8868 30.9862C12.4914 31.6556 14.2128 32.0003 15.9514 32.0003C17.6901 32.0003 19.4114 31.6556 21.016 30.9862C22.6206 30.3168 24.0766 29.3359 25.2997 28.1003C30.61 22.9006 30.61 14.4927 25.4104 9.40364Z",
    fill: "#EE4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7642 8.73941C21.7418 8.73941 22.5343 7.94691 22.5343 6.96931C22.5343 5.99172 21.7418 5.19922 20.7642 5.19922C19.7866 5.19922 18.9941 5.99172 18.9941 6.96931C18.9941 7.94691 19.7866 8.73941 20.7642 8.73941Z",
    fill: "#EE4C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9478_26596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo13);
export default __webpack_public_path__ + "static/media/logo13.a5f2ebbb17ecf473ce96ed0c2669adb6.svg";
export { ForwardRef as ReactComponent };